var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"aria-labelledby":_vm.iconName,"height":_vm.height,"viewBox":_vm.viewBox,"width":_vm.width,"xmlns":"http://www.w3.org/2000/svg"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }